/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: email.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateEmailRequest,
  CreateEmailResponse,
  GetEmailRequest,
  GetEmailResponse,
  ListEmailsByCaseIDRequest,
  ListEmailsByCaseIDResponse,
  UpdateEmailRequest,
  UpdateEmailResponse,
} from '../types/email';

export const createEmailService = (transport: Transport) => ({
  async createEmail(
    request: CreateEmailRequest,
    options: RequestOptions = {},
  ): Promise<CreateEmailResponse> {
    const { organization_id, program_id, case_id, ...body } = request;
    const url = getApiPath(API_METHODS.EmailService.CreateEmail, {
      organization_id,
      program_id,
      case_id,
    });
    return transport.post<CreateEmailResponse>(url, body, options);
  },

  async getEmail(
    request: GetEmailRequest,
    options: RequestOptions = {},
  ): Promise<GetEmailResponse> {
    const { organization_id, program_id, case_id, id } = request;
    const url = getApiPath(API_METHODS.EmailService.GetEmail, {
      organization_id,
      program_id,
      case_id,
      id,
    });
    return transport.get<GetEmailResponse>(url, options);
  },

  async listEmailsByCaseId(
    request: ListEmailsByCaseIDRequest,
    options: RequestOptions = {},
  ): Promise<ListEmailsByCaseIDResponse> {
    const { organization_id, program_id, case_id, ...params } = request;
    const url = getApiPath(API_METHODS.EmailService.ListEmailsByCaseID, {
      organization_id,
      program_id,
      case_id,
    });
    return transport.get<ListEmailsByCaseIDResponse>(url, { params, ...options });
  },

  async updateEmail(
    request: UpdateEmailRequest,
    options: RequestOptions = {},
  ): Promise<UpdateEmailResponse> {
    const { organization_id, program_id, case_id, id, ...body } = request;
    const url = getApiPath(API_METHODS.EmailService.UpdateEmail, {
      organization_id,
      program_id,
      case_id,
      id,
    });
    return transport.post<UpdateEmailResponse>(url, body, options);
  },
});

export type EmailService = ReturnType<typeof createEmailService>;
